import { Alpha3Code } from 'i18n-iso-countries'
import { ChangeEvent, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useCountries } from '@percent/admin-dashboard/common/hooks'
import { handleClickAsLink } from '@percent/admin-dashboard/common/utility/handleClickAsLink'
import {
  Box,
  FlagAvatar,
  Heading,
  Icon,
  SearchInput,
  Spacer,
  Table,
  TableBody,
  TableCell,
  TableProvider,
  TableRow
} from '@percent/lemonade'

export function RalphOracleListContainer() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const countries = useCountries()
  const [searchValue, setSearchValue] = useState('')

  const filteredCountries = useMemo(
    () => countries.filter(({ name }) => name.toLowerCase().includes(searchValue.trim().toLowerCase())),
    [countries, searchValue]
  )

  const columns = [{ id: t('ralphOracle.countryColumn') }, { id: '', props: { width: '48px' } }]

  return (
    <Box>
      <Heading level="h5">{t('ralphOracle.listTitle')}</Heading>
      <Spacer size={4} axis="vertical" />
      <SearchInput
        value={searchValue}
        onChange={(event: ChangeEvent<HTMLInputElement>) => setSearchValue(event.target.value)}
        handleClearValue={() => setSearchValue('')}
        placeholder={t('ralphOracle.searchPlaceholder')}
      />
      <Spacer size={4} axis="vertical" />
      <TableProvider
        columns={columns}
        totalResults={filteredCountries.length}
        isLoading={false}
        illustration="no-results"
        emptyTableTitle={t('ralphOracle.emptyTitle')}
      >
        <Table>
          <TableBody>
            {filteredCountries.map(({ code, name }) => (
              <TableRow
                key={code}
                data-testid={`ralph-oracle-country-${code}`}
                onClick={handleClickAsLink(`/ralph/oracle/${code}`, navigate)}
              >
                <TableCell>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FlagAvatar code3={code as Alpha3Code} />
                    {name}
                  </Box>
                </TableCell>
                <TableCell inlineStyle={{ textAlign: 'right' }}>
                  <Icon name="chevron-right" color="gray400" size={4} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableProvider>
    </Box>
  )
}
